// extracted by mini-css-extract-plugin
export default {"Error":"Error404_Error__Ice-v"};